export default {
    name: 'OfferForbidden',
    props: { show: Boolean, width: String, height: String, isMobile: Boolean },
    methods: {
        goToContact() {
            this.$router.push({ name: 'LandingPage' });
        }
    }
};
